// extracted by mini-css-extract-plugin
export default {"container":"Collections_container__fDLVd","header":"Collections_header__AR3Xm","buttonWrapper":"Collections_buttonWrapper__Jcwyc","content":"Collections_content__iUCNa"};